import { NgClass } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { Course } from "@app/core/domain/course";
import { ExamComponentForPlanCourse } from "@app/core/domain/exam-component";
import { CourseHelper } from "@app/core/domain/helpers/course-helper";
import { PlanHelper } from "@app/core/domain/helpers/plan-helper";
import { PlanLaterStateService } from "@app/shared/services/plan-later-state.service";
import { PlanStateService } from "@app/shared/services/plan-state.service";
import {
  InputCustomEvent,
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
  ModalController,
} from "@ionic/angular/standalone";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "pa-change-exam-component-modal",
  templateUrl: "./change-exam-component-modal.component.html",
  styleUrls: ["./change-exam-component-modal.component.scss"],
  imports: [
    IonRadio,
    IonRadioGroup,
    TranslatePipe,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonFooter,
    NgClass,
  ],
})
export class ChangeExamComponentModalComponent implements OnInit {
  @Input() course!: Course;
  @Input() examComponentsToChooseFrom!: ExamComponentForPlanCourse[];
  private readonly modalCtrl = inject(ModalController);
  private readonly courseHelper = inject(CourseHelper);
  private readonly planHelper = inject(PlanHelper);
  private readonly planStateService = inject(PlanStateService);
  private readonly planLaterStateService = inject(PlanLaterStateService);
  protected currentlyChosen: ExamComponentForPlanCourse | undefined;

  ngOnInit(): void {
    this.currentlyChosen = this.planHelper.findExamComponentThatMatchesCourse(
      this.examComponentsToChooseFrom,
      this.course,
    );
  }

  cancel(): void {
    this.modalCtrl.dismiss(null, "cancel").catch((error) => {
      console.error(
        "Error dismissing change-exam-component-modal (canceling the selection of an exam component):",
        error,
      );
    });
  }

  confirm(): void {
    this.modalCtrl.dismiss(this.currentlyChosen, "confirm").catch((error) => {
      console.error(
        `Error dismissing change-exam-component-modal (confirming selection of exam component ${JSON.stringify(this.currentlyChosen)}):`,
        error,
      );
    });
  }

  handleChange($event: Event): void {
    const changeEvent = $event as InputCustomEvent;

    if (changeEvent.detail.value) {
      const selectedUniqueId = changeEvent.detail.value;
      this.currentlyChosen = this.examComponentsToChooseFrom.find(
        (examComponent) => examComponent.uniqueId === selectedUniqueId,
      );
    }
  }

  isExamComponentOther(examComponent: ExamComponentForPlanCourse): boolean {
    return this.planHelper.isExamComponentOther(examComponent);
  }

  isLockedProposalComponent(examComponent: ExamComponentForPlanCourse): boolean {
    const plan = this.planStateService.currentSelectedPlan()!;
    return this.planHelper.isLockedProposalComponent(plan, examComponent);
  }

  getLockedProposalExplanation(): string {
    return this.planHelper.getLockedProposalExplanation(
      this.planStateService.currentSelectedPlan()!,
      this.planLaterStateService.getPlanLater()!,
      this.examComponentsToChooseFrom,
    );
  }

  getCourseName(): string {
    return this.courseHelper.getCourseName(this.course);
  }
}
